import { LCDocumentEditorUtils } from './LCDocumentEditorUtils';
import { EditorAttachedFilePlugin } from './EditorAttachedFilePlugin';
import { SelectionDialogs } from './../SelectionDialogs';
import { LectioJSUtils } from './../LectioJSUtils';
import { ILectioPlugin } from './Types';
import { LCDialogEditorUtils } from './LCEditorDialogUtils';

export class PluginLectioAudio implements ILectioPlugin {
	public Init(): void {
		CKEDITOR.plugins.add('lectioaudio', {
			init: (editorOuter: CKEDITOR.editor) => {

				editorOuter.filter.allow('img[data-lc-type];img[data-lc-resource]', 'lectioAudio');
				editorOuter.filter.allow('img[data-lc-external]', 'lectioAudio2');

				editorOuter.addCommand('lectioAudio', {
					exec: exec
				});

				editorOuter.ui.addButton('lectioAudioButton', {
					label: "Vælg lydfil",
					command: 'lectioAudio',
					icon: CKEDITOR.skin.icons.audio!.path,
					toolbar: ''
				});
			}
		});
	}
}



function createAudioHtml(documentInfo: SelectionDialogs.SelectedSerializedAnyFileId): string {
	LectioJSUtils.AssertNotNullOrEmpty(documentInfo.filename, "filename");
	const audioimg = CKEDITOR.skin.icons.playaudio!.path;
	const url = LCDocumentEditorUtils.GetResourceUrl(documentInfo.serializedId, documentInfo.filename).replace(/"/g, '&quot;');
	const html = '<img src="' + audioimg + '" width="24" height="24" data-lc-type="audio" data-lc-resource="' + url + '" />';
	return html;
}

function exec(editor: CKEDITOR.editor) {
	const editorConfig = LCDocumentEditorUtils.GetEditorConfig(editor);
	const resp = LCDialogEditorUtils.ShowSuitableContentPicker(
		editor,
		{ folderid: SelectionDialogs.InitialFolder.uploadFile },
		editorConfig);

	resp.promise.then(selection => {
		if (selection == null)
			return;

		let audioInfo: { html: string } | undefined;
		if (selection.type === 'serializedAnyFileId') {
			if (!selection.filename)
				throw new Error('Valgt LCDialogEditorUtils, men navn foelger ikke med? serializedid=' + selection.serializedId);
			const ext = EditorAttachedFilePlugin.GetFilenameExtension(selection.filename);
			const wellKnownImageExtension = 'mp3 mp4 m4a aac'.split(/ +/).filter(s => !!s);
			if (ext && wellKnownImageExtension.indexOf(ext) !== -1) {
				audioInfo = { html: createAudioHtml(selection) };
			}
		}

		if (!audioInfo) {
			LCDialogEditorUtils.ProcessNewHomeworkSelection(
				editor, selection,
				editorConfig.handleHomeworkPickerSelection,
				resp.editorHadFocus);
			return;
		}

		const res = LCDialogEditorUtils.ProcessNewHomeworkSelection(editor,
			{ type: 'html', html: audioInfo.html, creationManner: selection.creationManner },
			editorConfig.handleHomeworkPickerSelection,
			resp.editorHadFocus);
		if (res === 'client')
			LectioJSUtils.DispatchBrowserTestEvent('lectioaudioinserted');
	});

	return true;
}